import { onMounted, onUnmounted, ref, type Ref } from 'vue'

interface ScrollChrome {
  /** Ширина прогресс-бара, например "42%". */
  progressWidth: Ref<string>
  /** true, когда страница прокручена больше 24px (поджимает навбар). */
  navScrolled: Ref<boolean>
}

/**
 * Хром скролла: верхний прогресс-бар и состояние «прокручен» для навбара.
 * Значения отдаются как refs — биндятся в шаблоне через :style / :class.
 */
export function useScrollChrome(): ScrollChrome {
  const progressWidth = ref('0%')
  const navScrolled = ref(false)

  const onScroll = (): void => {
    const root = document.documentElement
    const scrolled = root.scrollTop / (root.scrollHeight - root.clientHeight || 1)
    progressWidth.value = `${scrolled * 100}%`
    navScrolled.value = root.scrollTop > 24
  }

  onMounted(() => {
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', onScroll)
    window.removeEventListener('resize', onScroll)
  })

  return { progressWidth, navScrolled }
}
